import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var Skeleton = function Skeleton(_ref) {
  var className = _ref.className,
    children = _ref.children,
    animated = _ref.animated;
  var classNames = clsx('tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600 light:tw-shadow-01', className);
  if (animated) {
    return /*#__PURE__*/_jsx("div", {
      "aria-live": "polite",
      "aria-busy": "true",
      className: clsx('tw-skeleton', classNames)
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "aria-live": "polite",
    "aria-busy": "true",
    className: classNames,
    children: children
  });
};